import { GET_WRITING_IMPLEMENT_TYPES_LOADING, GET_WRITING_IMPLEMENT_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getWritingImplementTypesSuccess = payload => {
    return ({
        type: GET_WRITING_IMPLEMENT_TYPES_SUCCESS,
        payload
    })
}

export const getWritingImplementTypesAsync = payload => dispatch => {
    return client.service('writing-implement-types').find()
		.then((response) => {
            dispatch(getWritingImplementTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}